import React from 'react';

const IndicatorSeparator = () => {
  return <></>;
};

export default IndicatorSeparator;
